__turbopack_context__.v({
  "container": "SectionTitleSimple-module-scss-module__7jclAq__container",
  "description": "SectionTitleSimple-module-scss-module__7jclAq__description",
  "title": "SectionTitleSimple-module-scss-module__7jclAq__title",
});
